export const onClickOutside = (
  element,
  handler,
  exception = null,
  once = false,
) => {
  const listener = (event) => {
    if (
      !element ||
      element.contains(event.target) ||
      (exception && exception.contains(event.target))
    ) {
      return
    }
    handler(event)
  }
  document.addEventListener("mousedown", listener, { once })
  document.addEventListener("touchstart", listener, { once })

  return () => {
    document.removeEventListener("mousedown", listener)
    document.removeEventListener("touchstart", listener)
  }
}
